import * as React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import { AfriqContainer } from "./AfriqContainer";
import { useTranslation } from "react-i18next";
import { ELinks } from "../../../utils/enum";
import * as footerService from "../../../Services/footerServices";
import { linksStringToData, setRef } from "../../../utils/footerUtils";
import { useHistory } from "react-router-dom";
import { ELinksURL } from "../../../utils/enum/linksOnFooter";

const useStyles = makeStyles((theme) => ({
    footer_container: {
        width: "100%",
        borderTop: "1px solid #DDDDDD",
        background: "#2B2B2B",
        position: "absolute",
        zIndex: 10,
    },
    gridContainer: {
        [theme.breakpoints.up("md")]: {
            "& > div:not(:first-child)": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: -54,
                    display: "block",
                    width: 1,
                    height: 127,
                    background: "#FFFFFF",
                },
            },
        },
    },
    gridItem: {
        position: "relative",
        marginTop: 30,
        marginBottom: 30,

        [theme.breakpoints.down("sm")]: {
            alignItems: "center",
        },
    },
    link: {
        display: "flex",
        alignItems: "center",
        fontSize: 14,
        fontWeight: 400,
        margin: 0,
        cursor: "pointer",
        color: "#FFFFFF",
        "&:hover": {
            textDecoration: "underline",
        },
        "&:not(:last-child)": {
            marginBottom: 20,
        },
    },
    skeletonItem: {
        background: '#3D3D3D',
        borderRadius: 4,
        width: '60%'
      },
      footerPlaceholder: {
        background: '#3D3D3D',
        borderRadius: 4,
        width: '60%'
      },
    icon: {
        marginRight: 18,
    },
}));

const Footer = () =>{
    const classes = useStyles();
    const { t } = useTranslation<'common'>();
    const [links, setLinks] = React.useState<any>({});
    const [, setGetingLinks] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const history = useHistory();

    /*const handleChangePage = (to: string) => () => {
        history.push(`/footer/${to}`, links[setRef(to).key]?.state);
    };*/

    React.useEffect(() => {
        const controller = new AbortController();

        //console.log("Fetching Footer data from Footer.tsx component");
        
        setIsLoading(true);
        footerService.getFooterData()
          .then((resp) => {
            if (resp?.links) {
              setLinks(linksStringToData(resp.links));
            }
          })
          .catch((err) => {
            if (err.name !== 'AbortError') {
              console.error(err);
            }
          })
          .finally(() => setIsLoading(false));
    
        return () => controller.abort();
      }, []);
    
      if (isLoading) {
        return (
          <div className={classes.footerPlaceholder}>
            <AfriqContainer>
              <div className={classes.skeletonItem} />
              <div className={classes.skeletonItem} />
              <div className={classes.skeletonItem} />
            </AfriqContainer>
          </div>
        );
    }

    return (
        <div className={classes.footer_container}>
            <AfriqContainer>
                <Grid
                    container
                    className={classes.gridContainer}
                    justifyContent="center"
                >
                    <Grid
                        item
                        sm={12}
                        md={4}
                        container
                        direction="column"
                        className={classes.gridItem}
                    >
                        <a
                            href={ELinksURL.FAQ}
                            //onClick={(e) => { e.preventDefault(); handleChangePage(ELinksURL.FAQ); }}
                            className={classes.link}
                            title={t("titleFooter.faq")}
                        >
                            FAQ
                        </a>
                        <a
                            href={ELinksURL.A_PROPOS_DE_NOUS}
                            //</Grid>onClick={(e) => { e.preventDefault(); handleChangePage(ELinksURL.A_PROPOS_DE_NOUS); }}
                            className={classes.link}
                            title={t("titleFooter.about_us")}
                        >
                            {t("label.a-propos-de-nous")}
                        </a>
                        <a
                            href={ELinksURL.NOS_VALEURS}
                            //onClick={(e) => { e.preventDefault(); handleChangePage(ELinksURL.NOS_VALEURS); }}
                            className={classes.link}
                            title={t("titleFooter.our_values")}
                        >
                            {t("label.nos-valeurs")}
                        </a>
                        <a
                            href={ELinksURL.NOUS_CONTACTER}
                            //onClick={(e) => { e.preventDefault(); handleChangePage(ELinksURL.NOUS_CONTACTER); }}
                            className={classes.link}
                            title={t("titleFooter.contact_us")}
                        >
                            {t("label.nous-contacter")}
                        </a>
                        <a 
                            href="/siteplan" 
                            className={classes.link}
                        >
                            {t("label.site-plan")}
                        </a>
                    </Grid>
                    <Grid
                        item
                        sm={12}
                        md={4}
                        container
                        direction="column"
                        className={classes.gridItem}
                    >
                        <a
                            href={ELinksURL.GARANTIE_DE_PROTECTION_DES_VOYAGEURS}
                            //onClick={(e) => { e.preventDefault(); handleChangePage(ELinksURL.GARANTIE_DE_PROTECTION_DES_VOYAGEURS); }}
                            className={classes.link}
                            title={t("titleFooter.traveler_protection_guarantee")}
                        >
                            {t("label.garantie-de-protection-des-voyageurs")}
                        </a>
                        <a
                            href={ELinksURL.CGU}
                            //onClick={(e) => { e.preventDefault(); handleChangePage(ELinksURL.CGU); }}
                            className={classes.link}
                            title={t("titleFooter.terms_and_conditions")}
                        >
                            {t("label.gcu")}
                        </a>
                        <a
                            href={ELinksURL.PDC}
                            //onClick={(e) => { e.preventDefault(); handleChangePage(ELinksURL.PDC); }}
                            className={classes.link}
                            title={t("titleFooter.privacy_policy")}
                        >
                            {t("label.dpp")}
                        </a>
                    </Grid>
                    <Grid
                        item
                        sm={12}
                        md={4}
                        container
                        direction="column"
                        className={classes.gridItem}
                    >
                        <a
                            href={links[setRef(ELinks.FACEBOOK).key]?.state ?? "#"}
                            target="_blank"
                            className={classes.link}
                            rel="noopener noreferrer"
                            title={t("titleFooter.follow_us_on_facebook")}
                        >
                            <FacebookIcon className={classes.icon} aria-label="Facebook" />
                            {setRef(ELinks.FACEBOOK).name}
                        </a>
                        <a
                            href={links[setRef(ELinks.INSTAGRAM).key]?.state ?? "#"}
                            target="_blank"
                            className={classes.link}
                            rel="noopener noreferrer"
                            title={t("titleFooter.follow_us_on_instagram")}
                        >
                            <InstagramIcon className={classes.icon} aria-label="Instagram" />
                            {setRef(ELinks.INSTAGRAM).name}
                        </a>
                        <a
                            href={links[setRef(ELinks.TWITTER).key]?.state ?? "#"}
                            target="_blank"
                            className={classes.link}
                            rel="noopener noreferrer"
                            title={t("titleFooter.follow_us_on_twitter")}
                        >
                            <TwitterIcon className={classes.icon} aria-label="Twitter" />
                            {setRef(ELinks.TWITTER).name}
                        </a>
                    </Grid>
                </Grid>
            </AfriqContainer>
        </div>
    );
}

export default Footer;
